import { render } from "./PackageOrderItemImportWrapper.vue?vue&type=template&id=57cc712a"
import script from "./PackageOrderItemImportWrapper.vue?vue&type=script&lang=js"
export * from "./PackageOrderItemImportWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__